export const SUBMIT_COMMENTS = 'SUBMIT_COMMENTS'
export const SUBMIT_COMMENTS_SUCCESS = 'SUBMIT_COMMENTS_SUCCESS'
export const SUBMIT_COMMENTS_FAILURE = 'SUBMIT_COMMENTS_FAILURE'
export const SUBMIT_COMMENTS_CANCEL = 'SUBMIT_COMMENTS_CANCEL'
